import * as React from 'react';
// @ts-expect-error
import {Controller} from 'react-hook-form';
// @ts-expect-error
import type {Control} from 'react-hook-form';

import {colors} from 'shells/colors/colors';
import {ContactIcon} from 'shells/icon/svg/contact-icon';
import {TwoLineOptionCard} from 'shells/option-card/two-line-option-card';

import type {FormFieldRowForDuplicateHelpers} from '../../../types';

import {getDisabledText} from '../preview/add-card/helpers';

import {Description} from './description';
import {getNameOptionIsDisabled} from './helpers';

import styles from './field-mapping.module.css';

type Props = {
    control: Control;
    name: string;
    fieldName: string;
    fieldLabel: string;
    otherFieldsOnForm: FormFieldRowForDuplicateHelpers[];
    onEditNameField: (updatedFieldName: string) => void;
};

export function PersonNameMapper(props: Props) {
    const fieldNameOptions = [
        {value: 'name', label: 'Name'},
        {value: 'firstName', label: 'First name'},
        {value: 'lastName', label: 'Last name'},
    ];

    return (
        <>
            <div className='py-8'>
                <Description fieldLabel={props.fieldLabel} />
            </div>
            <Controller
                name={`${props.name}.fieldName`}
                control={props.control}
                // @ts-expect-error
                render={({field}) => (
                    <div className={styles['cards-container']}>
                        {fieldNameOptions.map((option) => (
                            <div key={option.value} className={styles.card}>
                                <TwoLineOptionCard
                                    title={option.label}
                                    subtitle='Person'
                                    // @ts-expect-error
                                    icon={<ContactIcon size={16} color={colors.person} />}
                                    isSelected={option.value === props.fieldName}
                                    isDisabled={getNameOptionIsDisabled(
                                        props.otherFieldsOnForm,
                                        option.value
                                    )}
                                    disabledPopoverText={getDisabledText(
                                        props.otherFieldsOnForm,
                                        option.value,
                                        'Contacts'
                                    )}
                                    onClick={() => {
                                        field.onChange(option.value);
                                        // This updates the field list with the new name selection
                                        // so we disable adding the same name field again
                                        props.onEditNameField(option.value);
                                    }}
                                />
                            </div>
                        ))}
                    </div>
                )}
            />
        </>
    );
}
